import { wrapService } from 'actions/service_wrapper.actions';
import { fetchAutoLoanOffers } from 'externals/_services/product.service';
import {
  getFilteredAutoLoanOffers,
  buildAutoLoanQueryObject,
  buildAutoRefinanceloanDetails,
  REFINANCE,
  PURCHASE_NEW,
} from 'helpers/autoLoan.helper';
import { updateSessionTimeoutInLocal } from 'helpers/session';
import { completeAutoLoanFormForOffers } from 'actions/product.actions';
import {
  setAutoLoanPurchaseOffersDetails,
  setAutoLoanRefinanceOffersDetails,
} from 'partial/OfferDetails/actions/offerDetails.actions';

const a_fetchAutoLoanOffers = wrapService(fetchAutoLoanOffers, {
  name: 'a_fetchAutoLoanOffers',
});

export const loadAutoLoanOffers =
  ({
    currentSortType,
    autoLoanType,
    loanAmount,
    creditInfo,
    userInfo,
    refinanceAccount,
    isOcfPage,
  }) =>
  dispatch => {
    return new Promise((resolve, reject) => {
      let currentLoanDetails, queryObject;

      if (refinanceAccount) {
        currentLoanDetails = buildAutoRefinanceloanDetails(
          refinanceAccount,
          creditInfo,
        );
        queryObject = buildAutoLoanQueryObject(
          creditInfo,
          userInfo,
          {
            autoLoanPurpose: REFINANCE,
            loanAmount: currentLoanDetails.balance,
            rate: currentLoanDetails.apr,
            monthlyPayment: currentLoanDetails.monthlyPayment,
          },
          isOcfPage,
        );
        dispatch(setAutoLoanRefinanceOffersDetails({ queryObject }));
      } else {
        queryObject = buildAutoLoanQueryObject(
          creditInfo,
          userInfo,
          {
            autoLoanPurpose: PURCHASE_NEW,
            loanAmount: loanAmount,
          },
          isOcfPage,
        );
        dispatch(setAutoLoanPurchaseOffersDetails({ queryObject }));
      }

      dispatch(
        completeAutoLoanFormForOffers({
          queryObject,
          autoLoanType,
          currentLoanDetails,
        }),
      );
      dispatch(a_fetchAutoLoanOffers(queryObject))
        .then(res => {
          updateSessionTimeoutInLocal();
          const {
            autoLoanOffers,
            genericRefinanceLoanOffers,
            topRefinanceOffer,
          } = getFilteredAutoLoanOffers(
            res.items,
            currentSortType,
            refinanceAccount,
          );
          resolve({
            autoLoanOffers,
            genericRefinanceLoanOffers,
            currentLoanDetails,
            topRefinanceOffer,
          });
        })
        .catch(error => {
          reject(error);
        });
    });
  };
